import { AxiosRequestConfig } from "axios";
import { RequestHandler } from "./RequestHandler";
import ConfigService from "./ConfigService";
import SessionService from "./SessionService";
import CompanyService from "./CompanyService";
import AdminService from "./AdminService";
import JobsService from "./JobsService";

export class AppApi {
  configService: ConfigService;
  sessionService: SessionService;
  companyService: CompanyService;
  adminService: AdminService;
  jobsService: JobsService;

  // Can't use RootState type due to circular reference.
  constructor(state: any, baseURL: string) {
    const defaultConfig: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${state.sessionState.user?.idToken}`,
        "Content-Type": "application/json",
      },
      baseURL,
    };

    const requestHandler = new RequestHandler(baseURL, defaultConfig);
    this.configService = new ConfigService(requestHandler);
    this.sessionService = new SessionService(requestHandler);
    this.companyService = new CompanyService(requestHandler);
    this.adminService = new AdminService(requestHandler);
    this.jobsService = new JobsService(requestHandler);
  }
}
